import Lenis from 'lenis'
import 'lenis/dist/lenis.css'

import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger, Draggable)

class Scroller {
  constructor () {
    const lenis = new Lenis({
      normalizeWheel: true,
      keyboard: true
    })
    window.lenis = lenis

    /* scrollTrigger */
    lenis.on('scroll', ScrollTrigger.update)
    gsap.ticker.add(time => {
      lenis.raf(time * 1000)
    })
    gsap.ticker.lagSmoothing(0)

    // Add keyboard event handling for PageUp/PageDown
    this.handleKeyboardNavigation(lenis)

    /* custom scrollbar */
    const thumb = document.querySelector('[data-scrollbar-thumb]')
    const thumbs = document.querySelectorAll('[data-scrollbar-thumb]')
    const thumbHeight = thumb.getBoundingClientRect().height

    lenis.on('scroll', ({ progress }) => {
      thumb.style.transform = `translate3d(0,${
        progress * (window.innerHeight - thumbHeight)
      }px,0)`
      ScrollTrigger.update()
    })

    const inner = document.querySelector('[data-scrollbar-inner]')
    const maxThumbScroll = inner.clientHeight - thumb.clientHeight

    Draggable.create(thumb, {
      type: 'y',
      bounds: inner,
      onDrag () {
        const progress = this.y / maxThumbScroll
        const newScroll = progress * lenis.limit
        lenis.scrollTo(newScroll, { immediate: true })
      }
    })

    lenis.on('scroll', ({ scroll, limit }) => {
      const progress = scroll / limit
      gsap.to(thumbs[0], { y: progress * maxThumbScroll, duration: 0 })
    })
  }

  handleKeyboardNavigation (lenis) {
    // Add keyboard event listener for PageUp/PageDown
    document.addEventListener('keydown', (e) => {
      // Check for PageUp (keyCode 33) and PageDown (keyCode 34)
      if (e.key === 'PageUp' || e.keyCode === 33) {
        e.preventDefault()
        // Scroll up by viewport height
        const currentScroll = lenis.scroll
        const viewportHeight = window.innerHeight
        const newScroll = Math.max(0, currentScroll - viewportHeight)
        lenis.scrollTo(newScroll, { duration: 0.8 })
      } else if (e.key === 'PageDown' || e.keyCode === 34) {
        e.preventDefault()
        // Scroll down by viewport height
        const currentScroll = lenis.scroll
        const viewportHeight = window.innerHeight
        const maxScroll = lenis.limit
        const newScroll = Math.min(maxScroll, currentScroll + viewportHeight)
        lenis.scrollTo(newScroll, { duration: 0.8 })
      }
    })
  }
}

export default Scroller
